/**
 * @fileoverview Documented quality-management system radio group.
 */

import styles from "./Certifications.module.css";

const DocumentedSystemField = ({ section }) => {
  const { t, documentedSystem, setDocumentedSystem, handleRadioChange } =
    section;

  return (
    <div className={styles.inputGroup}>
      <label className={styles.inputLabel}>
        {t(
          "components.certifications.hasADocumentedQualityManagementSystemLabel",
        )}
      </label>
      <div className={styles.radioColumn}>
        <div className={`${styles.radioOption} ${styles.specialRadioOption}`}>
          <input
            type="radio"
            id="hasADocumentedQualityManagementSystemYes1"
            name="hasADocumentedQualityManagementSystem"
            value={0}
            checked={documentedSystem === 0}
            onChange={() => {
              setDocumentedSystem(0);
              handleRadioChange("tieneSistemaDocumentado", 0);
            }}
            className={styles.radio}
          />
          <label
            htmlFor="hasADocumentedQualityManagementSystemYes1"
            className={styles.radioLabel}
          >
            {t(
              "components.certifications.hasADocumentedQualityManagementSystemYes1",
            )}
          </label>
        </div>
        <div className={`${styles.radioOption} ${styles.specialRadioOption}`}>
          <input
            type="radio"
            id="hasADocumentedQualityManagementSystemYes2"
            name="hasADocumentedQualityManagementSystem"
            value={1}
            checked={documentedSystem === 1}
            onChange={() => {
              setDocumentedSystem(1);
              handleRadioChange("tieneSistemaDocumentado", 1);
            }}
            className={styles.radio}
          />
          <label
            htmlFor="hasADocumentedQualityManagementSystemYes2"
            className={styles.radioLabel}
          >
            {t(
              "components.certifications.hasADocumentedQualityManagementSystemYes2",
            )}
          </label>
        </div>
        <div className={styles.radioOption}>
          <input
            type="radio"
            id="hasADocumentedQualityManagementSystemNo"
            name="hasADocumentedQualityManagementSystem"
            value={2}
            checked={documentedSystem === 2}
            onChange={() => {
              setDocumentedSystem(2);
              handleRadioChange("tieneSistemaDocumentado", 2);
            }}
            className={styles.radio}
          />
          <label
            htmlFor="hasADocumentedQualityManagementSystemNo"
            className={styles.radioLabel}
          >
            {t(
              "components.certifications.hasADocumentedQualityManagementSystemNo",
            )}
          </label>
        </div>
      </div>
      <p
        className={`${styles.notVisibleFieldMessage} ${styles.specialSpacing}`}
      >
        *
        {t(
          "components.certifications.notVisibleFieldsForOtherMembersLabel",
        )}
      </p>
    </div>
  );
};

export default DocumentedSystemField;
